import { Component, Vue } from 'vue-property-decorator';

import apiService from '@/services/api.service';

import template from './no-subscription.vue';
import { LocalUser, Action } from '@/store/store.definitions';

@Component({
  mixins: [template],
})
export default class NoSubscription extends Vue {
  userAmount: number = 0;
  subscription: { type: number } = { type: 1 };

  async created() {
    if (this.user.isAdmin) {
      this.userAmount = await apiService.companyUserAmount(this.user.companyId);
      this.subscription.type = this.userAmount < 10 ? 1 : this.userAmount < 30 ? 2 : 3;
    }
  }

  get user(): LocalUser {
    return this.$Store.state.user;
  }

  logout(): void {
    this.$Store.dispatch(Action.LOGOUT_USER);
    this.$router.push({ path: '/login' });
  }

  async chooseSubscription(): Promise<void> {
    try {
      const result = await apiService.selectSubscription({ companyId: this.user.companyId, userId: this.user._id, type: this.subscription.type });
      window.location.assign(result.redirectUrl);
    } catch (e) {

    }
  }
}